import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid2 as Grid, Paper, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

type AlertStyleProps = {
	severity: string;
};

const useStyles = makeStyles((theme) => ({
	paper: (props: AlertStyleProps) => ({
		width: "100%",
		borderWidth: 2,
		borderColor:
			props.severity === "error"
				? theme.palette.custom.jbColours.darkRed
				: props.severity === "warning"
					? theme.palette.custom.jbColours.darkOrange
					: props.severity === "success"
						? theme.palette.custom.jbColours.darkGreen
						: theme.palette.custom.jbColours.darkBlue,
		backgroundColor:
			props.severity === "error"
				? theme.palette.custom.jbColours.lightRed
				: props.severity === "warning"
					? theme.palette.custom.jbColours.lightOrange
					: props.severity === "success"
						? theme.palette.custom.jbColours.lightGreen
						: theme.palette.custom.jbColours.lightBlue,
		padding: 10,
	}),
	icon: (props: AlertStyleProps) => ({
		color:
			props.severity === "error"
				? theme.palette.custom.jbColours.darkRed
				: props.severity === "warning"
					? theme.palette.custom.jbColours.darkOrange
					: props.severity === "success"
						? theme.palette.custom.jbColours.darkGreen
						: theme.palette.custom.jbColours.darkBlue,
		fontSize: 20,
		margin: "1px 0 0 0",
	}),
	title: (props: AlertStyleProps) => ({
		color:
			props.severity === "error"
				? theme.palette.custom.jbColours.darkRed
				: props.severity === "warning"
					? theme.palette.custom.jbColours.darkOrange
					: props.severity === "success"
						? theme.palette.custom.jbColours.darkGreen
						: theme.palette.custom.jbColours.darkBlue,
	}),
	message: (props: AlertStyleProps) => ({
		textDecoration: "none",
		color: theme.palette.getContrastText(
			props.severity === "error"
				? theme.palette.custom.jbColours.lightRed
				: props.severity === "warning"
					? theme.palette.custom.jbColours.lightOrange
					: props.severity === "success"
						? theme.palette.custom.jbColours.lightGreen
						: theme.palette.custom.jbColours.lightBlue
		),
	}),
	gridItemMaxWidth: {
		maxWidth: "32px",
	},
}));
export type AlertInformationProps = {
	message: string;
	severity: string;
	title?: string;
	icon?: React.ReactElement;
};
export function AlertInformation(props: AlertInformationProps) {
	const classes = useStyles({ severity: props.severity });
	const { message, severity, title, icon } = props;

	return (
		<Paper variant="outlined" className={classes.paper} sx={{ mb: 1 }}>
			<Grid container direction="row">
				<Grid container size={1} className={classes.gridItemMaxWidth}>
					{icon ? (
						<>{icon}</>
					) : severity === "success" ? (
						<CheckCircleIcon className={classes.icon} />
					) : (
						<ErrorIcon className={classes.icon} />
					)}
				</Grid>
				<Grid container size={11} direction="column">
					{title && (
						<Grid size="grow">
							<Typography variant="subtitle2" className={classes.title}>
								{title}
							</Typography>
						</Grid>
					)}
					<Grid size="grow" className={classes.message}>
						<Typography variant="caption">{message}</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
}
